export default function HighlightSection({ highlights }) {
  return (
    <div className="tw-max-w-8xl tw-mx-auto">
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-6 md:tw-gap-6 tw-gap-3">
        {highlights.map((feature, index) => (
          <div key={index} className="tw-relative tw-mb-2 md:tw-mb-0">
            <div
              className={`tw-absolute tw-inset-0 tw-bg-${feature.color}-100 tw-transform tw-rotate-1 tw-rounded-lg tw--z-10`}
            ></div>
            <div className="tw-rounded-lg tw-overflow-hidden tw-shadow-md">
              <div className="tw-relative">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="tw-w-full tw-h-62 md:tw-h-80 tw-object-cover"
                />
              </div>
            </div>

            <div className="tw-p-3 md:tw-p-4 tw-h-auto md:tw-h-60 tw-flex tw-flex-col">
              <h3 className="tw-text-xl tw-font-bold tw-mb-2 md:tw-mb-3">
                {feature.title}
              </h3>
              <p className="tw-text-gray-700 tw-mb-2 md:tw-mb-4 tw-text-m tw-flex-grow">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
